// Goblic's logo mark: the clay goblin head (public/brand/). It's the brand,
// not an illustration, so it stays when illustrations are switched off.

export function LogoMark({ size = 28 }: { size?: number }) {
  return (
    <img
      src="/brand/logo-128.webp"
      alt=""
      aria-hidden
      width={size}
      height={size}
      className="shrink-0 select-none object-contain"
      style={{ width: size, height: size }}
    />
  )
}
